export const THEME = {
  primary: '#006064',
  secondary: '#00838F',
  primaryLight: '#428e92',
  primaryDark: '#00363a',
  text: '#1F2937',
  subtext: '#6B7280',
  background: '#F9FAFB',
  cardbg: '#FFFFFF',
  border: '#E5E7EB',
  error: '#EF4444',
  success: '#10B981',
  warning: '#F59E0B',
  info: '#3B82F6',
};

export const gradients = {
  primary: 'linear-gradient(135deg, #006064 0%, #428e92 100%)',
  dark: 'linear-gradient(135deg, #1F2937 0%, #374151 100%)',
};

export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
}; 